import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconChevronDown: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7071 0.792893C11.3166 0.402369 10.6834 0.402369 10.2929 0.792893L6 5.08579L1.70711 0.792893C1.31658 0.402369 0.683417 0.402369 0.292893 0.792893C-0.0976304 1.18342 -0.0976304 1.81658 0.292893 2.20711L5.29289 7.20711C5.68342 7.59763 6.31658 7.59763 6.70711 7.20711L11.7071 2.20711C12.0976 1.81658 12.0976 1.18342 11.7071 0.792893Z"
      />
    </svg>
  </IconStyled>
);

IconChevronDown.defaultProps = iconDefaultProps;
IconChevronDown.displayName = 'IconChevronDown';

export default IconChevronDown;
